import React from "react";
import {
  Box,
  InputLabel,
  Select,
  Typography,
  Grid,
  MenuItem,
} from "@mui/material";

interface PlaceOfServiceProps {
  place_of_service: string;
  onChange: (field: "place_of_service", value: string) => void;
  options: any[];
  claimStatus: string;
}

const PlaceOfService: React.FC<PlaceOfServiceProps> = ({
  place_of_service,
  onChange,
  options,
  claimStatus,
}) => {
  console.log("place_of_service", place_of_service);
  return (
    <Grid container spacing={2} alignItems="center" sx={{ minHeight: "160px" }}>
      <Grid item xs={6.5}>
        <Box>
          <Typography
            sx={{
              color: "#A29D9B",
              fontSize: "12px",
              lineHeight: "26px",
              fontWeight: 700,
            }}
          >
            Key Details
          </Typography>
          <p
            style={{
              color: "#707070",
              fontSize: "10px",
              lineHeight: "14px",
              fontWeight: 400,
            }}
          >
            We are using the same place of service as the associated encounter.
            You can also change this at your discretion, however{" "}
            <b>this is uncommon.</b>
          </p>
        </Box>
      </Grid>

      <Grid item xs={5.5}>
        <Box>
          <InputLabel
            htmlFor="place-of-service"
            sx={{
              color: "#A29D9B",
              fontWeight: 700,
              fontSize: "12px",
              lineHeight: "26px",
            }}
          >
            Place of Service*
          </InputLabel>
          <Box className="field-container" sx={{ marginLeft: "0px" }}>
            <Select
              id="place-of-service"
              value={place_of_service}
              required
              variant="outlined"
              className="the-field"
              disabled={claimStatus === "submitted" || claimStatus === "pending_submission"}
              onChange={(e) => onChange("place_of_service", e.target.value)}
            >
              <MenuItem value="Select Place of Service" disabled>
                Place of Service
              </MenuItem>
              {options?.map((option) => (
                <MenuItem
                  key={option.code}
                  value={`${option.code} - ${option.name}`}
                >
                  {`${option.code} - ${option.name}`}
                </MenuItem>
              ))}
            </Select>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default PlaceOfService;
